import moment from 'moment'

import { ManagementNoteModal } from '@apps-common/apps/portal/pages/units/pages/manage/pages/notes/components'
import { ModalButton } from '@apps-common/components/modals'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { INoteModel } from '@apps-common/types/management/note'

interface IProps {
  note: INoteModel
}

export const ManagementNoteListCard: React.FC<IProps> = ({ note }) => {
  const { noteId, entityId, noteContent, dateEdited } = note

  return (
    <div className='w-full'>
      <ModalButton
        component={ManagementNoteModal}
        disabled={false}
        componentProps={{
          entityId,
          noteId
        }}
        classes='relative pt-4 sm:pt-3.5 px-4 py-3.5 bg-surface-2 rounded-[30px] text-[0.8em] leading-[1.4em] sm:text-[0.95em] jost-light flex flex-col gap-[10px] w-full hover:!opacity-90'
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
      >
        <div className='flex flex-col w-full gap-[5px]'>
          <div className='grow w-full flex items-start justify-between gap-[7px] sm:gap-[5px]'>
            <div className='grow relative overflow-hidden flex flex-col h-[73px] items-between justify-center gap-[5px] text-left bg-surface-2 text-primary px-[15px] pb-[10px] pt-[25px] rounded-[20px] min-h-[60px] sm:min-h-[70px]'>
              <div className='absolute top-[0px] right-[0px] px-[15px] text-[0.8rem] bg-surface-2 rounded-bl-[15px] inline-block ml-auto'>
                {moment(dateEdited).format('Do MMM YY')}
              </div>
              <div className='text-ellipsis line-clamp-2'>{noteContent}</div>
            </div>
          </div>
        </div>
      </ModalButton>
    </div>
  )
}
